import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { DatosServiciosGestionServicios } from "../DatosServiciosGestionServicios/DatosServiciosGestionServicios";

export const ACTEditarReporte: EntityClientAction = {
    name: 'ACTEditarReporte',
    label: 'Editar',
    title: <Text fw={700}>Editar</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['dasp_brwAutorizacionGeneral', 'dasp_brwAutorizacionGeneralAppSupervisor'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const datosServiciosGestionProductos = new DatosServiciosGestionServicios(entity.API.client);
        datosServiciosGestionProductos.def.columns.c_visita_id.value = selectedKeys![0].c_visita_id as unknown as string || '';
        datosServiciosGestionProductos.def.columns.c_cliente_id.value = selectedKeys![0].c_cliente_id as unknown as string || '';
        datosServiciosGestionProductos.def.columns.c_producto_id.value = selectedKeys![0].c_producto_id as unknown as string || '';
        datosServiciosGestionProductos.def.columns.c_servicio_id.value = selectedKeys![0].c_servicio_id as unknown as string || '';
        datosServiciosGestionProductos.def.columns.c_paso_id.value = selectedKeys![0].c_paso_id as unknown as string || '';
        datosServiciosGestionProductos.def.columns.c_datos_servicio_id.value = selectedKeys![0].c_paso_id as unknown as string || '';
        datosServiciosGestionProductos.def.columns.c_datos_servicio_set_id.value = selectedKeys![0].c_datos_servicio_set_id as unknown as string || '';

        await openEntityForm({
            modals: modal,
            formProps: {
                entity: datosServiciosGestionProductos,
                initialFormMode: 'edit',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(); },
            handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(); }
        });

        return false;
    }
}